import React from "react";
import { Box, Grid, Typography, Container, Paper } from "@mui/material";

import {
    FaShieldAlt,
    FaCreditCard,
    FaShippingFast,
    FaCheckCircle,
} from "react-icons/fa";

const BenefitsRow = () => {
    const benefits = [
        {
            icon: <FaShieldAlt size={26} />,
            title: "Garantia Premium",
            text: "Até 5 dias de garantia em produtos selecionados.",
        },
        {
            icon: <FaCreditCard size={26} />,
            title: "Pagamento Seguro",
            text: "Parcele em até 12x sem juros.",
        },
        {
            icon: <FaShippingFast size={26} />,
            title: "Entrega Rápida",
            text: "Envio para todo o Brasil com rastreamento.",
        },
        {
            icon: <FaCheckCircle size={26} />,
            title: "Qualidade Certificada",
            text: "Produtos originais e testados.",
        },
    ];

    return (
        <Container maxWidth="xl" sx={{ mt: 8, mb: 4 }}>
            <Grid
                container
                spacing={3}
                justifyContent="center"
                alignItems="stretch"
                sx={{
                    width: "100%",
                    margin: "0 auto",
                }}
            >
                {benefits.map((item, i) => (
                    <Grid item xs={12} sm={6} md={3} key={i} display="flex" justifyContent="center">

                        <Paper
                            elevation={4}
                            sx={{
                                width: { xs: "100%", sm: "350px", md: "330px" },
                                height: 180,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                borderRadius: "20px",
                                paddingX: 3,
                                paddingY: 3,
                                backgroundColor: "white",
                                transition: "0.35s cubic-bezier(.21,.6,.29,1.1)",
                                boxShadow: "0 3px 10px rgba(0,0,0,0.08)",

                                "&:hover": {
                                    transform: "translateY(-8px)",
                                    boxShadow: "0 18px 35px rgba(0,0,0,0.18)",
                                },

                                "&:hover .benefit-icon": {
                                    backgroundColor: "var(--azul)",
                                    color: "white",
                                    transform: "scale(1.15)",
                                },
                            }}
                        >

                            <Box
                                className="benefit-icon"
                                sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: "14px",
                                    backgroundColor: "rgba(30,43,78,0.06)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "var(--azul)",
                                    mb: 1.5,
                                    transition: "0.35s",
                                }}
                            >
                                {item.icon}
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 17,
                                    color: "var(--cinza)",
                                }}
                            >
                                {item.title}
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 1,
                                    color: "#5a5a5a",
                                    fontSize: 14,
                                    maxWidth: 200,
                                    lineHeight: 1.45,
                                }}
                            >
                                {item.text}
                            </Typography>

                        </Paper>

                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default BenefitsRow;
